var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/Meteo
 */
import Control from './Control';
import MapControls from './MapControls';
import { i18n } from '../dictionary';
import LonLat from '../LonLat';
import Marker from '../Marker';
import Icon from '../Icon';
import ServicePois from '../service/Pois';
import { IMG } from '../globals';
import VControlButton from '../view/VControlButton';
import VMeteoPopup from '../view/VMeteoPopup';
import RainWeatherLayer, { EventType as WeatherLayerEventType } from '../layer/RainWeather';
import VDropDown, { EventType as DropDownEventType } from '../view/VDropDownMultiple';
import VWeatherInformation from '../view/VWeatherInformation';
import ActiveFires from '../layer/ActiveFires';
/**
* Options to enable meteo
* @api
*/
export var Options = {
    /**
     * Rain radar
     * @api
     */
    RAIN: 'rain',
    /**
     * Meteo
     * @api
     */
    METEO: 'meteo',
    /**
     * Active fires
     * @api
     */
    FIRES: 'fires',
};
/**
 * @classdesc
 * <b>Javascript ES5</b>
 *
 * ```js
 * const control = new cercaliagl.control.Meteo();
 * map.addControl(control);
 * ```
 * <br/>
 * This control obtains POIs and draw it to map. It shows meteo forecast for all localities in Spain and principal towns
 * for the next days. Every day all forecasts are updated.<br/>
 * Spain feeds are provided by <a href="http://www.aemet.es/es/portada">AEMET - Agencia Estatal de Metereología</a><br/>
 * The Rest of cities <a href="https://openweathermap.org/">OpenWeatherMap</a>
 * <br/>
 * @constructor
 * @extends {Control}
 * @api
 */
var Meteo = /** @class */ (function (_super) {
    __extends(Meteo, _super);
    function Meteo() {
        var _this = this;
        var controlButton = new VControlButton('meteo');
        var element = controlButton.getElement();
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.Meteo',
            name: MapControls.METEO,
        }) || this;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {RainWeatherLayer}
         */
        _this.rainWeatherLayer_ = null;
        /**
         * @private
         * @type {ActiveFires}
         */
        _this.activeFiresLayer_ = null;
        /**
         * @private
         * @type {VMeteoPopup}
         */
        _this.meteoPopup_ = new VMeteoPopup();
        /**
         * @private
         * @type {VWeatherInformation}
         */
        _this.weatherInformation_ = new VWeatherInformation();
        /**
         * @private
         * @type {ServicePois|undefined}
         */
        _this.poisService_ = undefined;
        /**
         * @private
         * @type {Array.<Marker>}
         */
        _this.markers_ = [];
        /**
         * @private
         * @type {number|undefined}
         */
        _this.lastZoom_ = 99;
        /**
         * @private
         * @type {VDropDown}
         */
        _this.dropdown_ = new VDropDown();
        // this.dropdown_.setSelected(null);
        /**
         * @private
         * @type {Array.<import("../view/VDropDownMultiple").Item>}
         */
        _this.items_ = [
            {
                id: Options.RAIN,
                value: i18n('rainRadar'),
                iconName: 'icon-pluja_diecte1',
                paths: ['path1', 'path2', 'path3', 'path4', 'path5', 'path6', 'path7', 'path8'],
                enableOption: _this.enableRainWeather.bind(_this),
                disableOption: _this.disableRainWeather.bind(_this),
            },
            {
                id: Options.METEO,
                value: i18n('tooltipMeteo'),
                iconName: 'icon-meteo',
                enableOption: _this.enableMeteo.bind(_this),
                disableOption: _this.disableMeteo.bind(_this),
            },
            {
                id: Options.FIRES,
                value: i18n('activeFires'),
                enableOption: _this.enableActiveFires.bind(_this),
                disableOption: _this.disableActiveFires.bind(_this),
            },
        ];
        /**
         * @private
         * @type {boolean}
         */
        _this.enabled_ = false;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    Meteo.prototype.initialize_ = function () {
        var _this = this;
        this.controlButton_.setTooltip(i18n('tooltipMeteo'));
        // Events
        this.element_.addEventListener('click', this.handleClick_.bind(this));
        window.addEventListener('resize', function () { return _this.adjustPosition_(_this.dropdown_); });
        this.dropdown_.on(DropDownEventType.SELECTED, function (item) { return item.enableOption(); });
        this.dropdown_.on(DropDownEventType.DESELECTED, function (item) { return item.disableOption(); });
        this.initializeListItems_();
    };
    /**
     * @private
     */
    Meteo.prototype.initializeListItems_ = function () {
        var _this = this;
        this.items_.forEach(function (item) {
            _this.dropdown_.add(item);
        });
    };
    /**
    * @override
    * @param {string} option Option to enable. See above
    * @param {boolean} manual - Whether the feature was enabled manually or not. False by default
    * @api
    */
    Meteo.prototype.enable = function (option, manual) {
        if (option === void 0) { option = Options.METEO; }
        if (manual === void 0) { manual = false; }
        var itemAssociatedToOption = this.items_.find(function (item) { return item.id === option; });
        if (itemAssociatedToOption) {
            // this.dropdown_.selectItem(option.id);
            itemAssociatedToOption.enableOption(manual);
        }
    };
    /**
     * @override
     * @param {string} option Option to disable. See above
     * @param {boolean} manual - Whether the feature was disabled manually or not. False by default
     * @api
    */
    Meteo.prototype.disable = function (option, manual) {
        if (option === void 0) { option = Options.METEO; }
        if (manual === void 0) { manual = false; }
        var itemAssociatedToOption = this.items_.find(function (item) { return item.id === option; });
        if (itemAssociatedToOption) {
            itemAssociatedToOption.disableOption(manual);
        }
    };
    /**
     * @private
     */
    Meteo.prototype.handleClick_ = function () {
        if (!this.dropdown_.isVisible()) {
            // Right align to button.
            var container = this.getMap().getContainer();
            if (!this.dropdown_.getElement().parentElement) {
                this.dropdown_.appendTo(container);
            }
            this.adjustPosition_(this.dropdown_);
            this.dropdown_.show();
        }
        else {
            this.dropdown_.hide();
        }
    };
    /**
     * Enables the Meteo feature.
     * @param {boolean} manual - Whether the feature was enabled manually or not. False by default
     * @private
     */
    Meteo.prototype.enableMeteo = function (manual) {
        if (manual === void 0) { manual = false; }
        var cercaliaMap = this.getCercaliaMap();
        if (this.poisService_ === undefined) {
            var mbMap = this.getMap();
            var zoom = cercaliaMap.getZoom();
            if (zoom !== undefined) {
                var categories = [Meteo.getCategoryByZoom(zoom)];
                this.poisService_ = new ServicePois(/** @type {import('../service/Pois').PoisOptions} */ ({
                    categories: categories,
                    searchByScale: true,
                }));
                this.handleMeteoMoveEnd_(); // Primera peticion al activarlo
                mbMap.on('moveend', this.handleMeteoMoveEnd_.bind(this));
            }
        }
        this.enabled_ = true;
        this.controlButton_.enable();
        if (!this.meteoPopup_.getElement().closest('body')) {
            var container = this.getMap().getContainer();
            this.meteoPopup_.appendTo(container);
        }
        if (manual) {
            this.dropdown_.selectItem(Options.METEO);
        }
        this.dropdown_.hide();
    };
    /**
     * Disables the Meteo feature.
    * @param {boolean} manual - Whether the feature was disabled manually or not. False by default
     */
    Meteo.prototype.disableMeteo = function (manual) {
        if (manual === void 0) { manual = false; }
        if (this.poisService_ !== undefined) {
            this.removeMarkers_();
            this.poisService_ = undefined;
            var mbMap = this.getMap();
            mbMap.off('moveend', this.handleMeteoMoveEnd_.bind(this));
        }
        this.enabled_ = false;
        if (manual) {
            this.dropdown_.deselectItem(Options.METEO);
        }
        if (this.dropdown_.getNumberOfElementsSelected() === 0) {
            this.controlButton_.disable();
        }
        this.dropdown_.hide();
    };
    /**
     * Enables the rain weather layer and displays the weather information on the map.
     * @param {boolean} manual - Whether the enableRainWeather method was called manually or not. False by default
     * @private
     */
    Meteo.prototype.enableRainWeather = function (manual) {
        if (manual === void 0) { manual = false; }
        if (!this.rainWeatherLayer_) {
            this.createRainWeatherLayer_();
        }
        if (!this.weatherInformation_.getElement().closest('body')) {
            var container = this.getMap().getContainer();
            this.weatherInformation_.appendTo(container);
        }
        this.controlButton_.enable();
        if (manual) {
            this.dropdown_.selectItem(Options.RAIN);
        }
        this.dropdown_.hide();
    };
    /**
     * Disables the rain weather layer and hides the dropdown and weather information.
     * If no elements are selected in the dropdown, the control button is disabled.
     * @param {boolean} manual - Whether the disableRainWeather method was called manually or not. False by default
     * @private
     */
    Meteo.prototype.disableRainWeather = function (manual) {
        if (manual === void 0) { manual = false; }
        if (this.rainWeatherLayer_) {
            this.removeRainWeatherLayer_();
            if (manual) {
                this.dropdown_.deselectItem(Options.RAIN);
            }
            if (this.dropdown_.getNumberOfElementsSelected() === 0) {
                this.controlButton_.disable();
            }
        }
        this.dropdown_.hide();
        this.weatherInformation_.hide();
    };
    /**
     * Enables the active fires layer.
     * @param {boolean} manual - Whether the enableActiveFires method was called manually or not. False by default
     * @private
     */
    Meteo.prototype.enableActiveFires = function (manual) {
        if (manual === void 0) { manual = false; }
        if (!this.activeFiresLayer_) {
            this.createActiveFiresLayer_();
        }
        this.controlButton_.enable();
        if (manual) {
            this.dropdown_.selectItem(Options.FIRES);
        }
        this.dropdown_.hide();
    };
    /**
     * Disables the active fires layer.
     * If no elements are selected in the dropdown, the control button is disabled.
     * @param {boolean} manual - Whether the disableActiveFires method was called manually or not. False by default
     * @private
     */
    Meteo.prototype.disableActiveFires = function (manual) {
        if (manual === void 0) { manual = false; }
        if (this.activeFiresLayer_) {
            this.removeActiveFiresLayer_();
            if (manual) {
                this.dropdown_.deselectItem(Options.FIRES);
            }
            if (this.dropdown_.getNumberOfElementsSelected() === 0) {
                this.controlButton_.disable();
            }
        }
        this.dropdown_.hide();
    };
    /**
     * @static
     * @param {number} zoom Zoom
     * @return {string} categoryname Category name for zoom.
     */
    Meteo.getCategoryByZoom = function (zoom) {
        if (zoom < 4) {
            return 'D00M13';
        }
        if (zoom >= 4 && zoom < 5) {
            return 'D00M12';
        }
        if (zoom >= 5 && zoom < 6) {
            return 'D00M11';
        }
        if (zoom >= 6 && zoom < 7) {
            return 'D00M10';
        }
        if (zoom >= 7 && zoom < 8) {
            return 'D00M09';
        }
        if (zoom >= 8 && zoom < 10) {
            return 'D00M08';
        }
        if (zoom >= 10 && zoom < 11) {
            return 'D00M07';
        }
        if (zoom >= 11 && zoom < 12) {
            return 'D00M06';
        }
        return 'D00M05';
    };
    /**
     * @private
     */
    Meteo.prototype.handleMeteoMoveEnd_ = function () {
        if (this.poisService_ !== undefined) {
            var cercaliaMap = this.getCercaliaMap();
            var zoomAct = cercaliaMap.getZoom();
            var bounds = cercaliaMap.getBounds();
            var poisBounds = this.poisService_.getBounds();
            if (zoomAct
                && (this.poisService_.getResponse() === null
                    || zoomAct !== this.lastZoom_
                    || (bounds !== undefined && !poisBounds.containsBounds(bounds)))) {
                var map = this.getCercaliaMap();
                var size = map.getSize();
                var doubleBounds = cercaliaMap.getBounds().getDouble();
                var categories = [Meteo.getCategoryByZoom(zoomAct)];
                this.lastZoom_ = cercaliaMap.getZoom();
                this.poisService_.setQueryCategories(categories);
                this.poisService_.setBounds(doubleBounds); // Doble de extension (sumamos x0.5) por todos los lados
                this.poisService_.setWidth(size[0] * 2);
                var finalHeight = size[1] !== 0 ? size[1] * 2 : document.getElementById(map.getContainerId()).offsetHeight * 2;
                this.poisService_.setHeight(finalHeight);
                this.poisService_.doPoisRequest(this.handlePoisResponse_.bind(this));
            }
        }
    };
    /**
     * @private
     * @param {import('../servers').PoisResult} data Server data response JSON.
     */
    Meteo.prototype.handlePoisResponse_ = function (data) {
        this.removeMarkers_();
        if (data.cercalia.map.gpoicats && data.cercalia.map.gpoicats.poilist) {
            var pois = data.cercalia.map.gpoicats.poilist.poi;
            // Puede ser que solo devuelva un elemento. Por lo tanto lo convertimos a un array
            if (!Array.isArray(pois)) {
                pois = [pois];
            }
            if (pois.length > 0 && pois[0] !== null) {
                var cercaliaMap = this.getCercaliaMap();
                for (var i = 0; i < pois.length; i += 1) {
                    var poi = pois[i];
                    if (poi) {
                        var id = poi.id;
                        var locality = poi.name.value;
                        var poiInfo = poi.info.value;
                        var info = poiInfo.split('|');
                        var img = "".concat(IMG, "/meteo/big/").concat(info[6], ".png");
                        var marker = new Marker(/** @type {import('../Marker').MarkerOptions} */ ({
                            position: new LonLat(poi.coord.x, poi.coord.y),
                            icon: new Icon(/** @type {import('../Icon').IconOptions} */ ({
                                src: img,
                            })),
                            onClick: this.handleMeteoMouseOver_.bind(this, id, locality, poiInfo),
                        }));
                        this.markers_.push(marker);
                    }
                }
                cercaliaMap.addMarkers(this.markers_);
            }
        }
    };
    /**
     * @private
     * @param {string} id Poi id.
     * @param {string} locality Locality name.
     * @param {string} info Info poi field.
     */
    Meteo.prototype.handleMeteoMouseOver_ = function (id, locality, info) {
        this.meteoPopup_.update(id, locality, info);
        if (!this.meteoPopup_.isVisible()) {
            this.viewInterface_.closePopups();
            this.meteoPopup_.show();
        }
    };
    /**
     * @private
     */
    Meteo.prototype.handleMeteoMouseOut_ = function () {
        this.meteoPopup_.hide();
    };
    /**
     * Remove all meteo markers.
     * @private
     */
    Meteo.prototype.removeMarkers_ = function () {
        var cercaliaMap = this.getCercaliaMap();
        if (this.markers_.length > 0) {
            cercaliaMap.removeMarkers(this.markers_);
            for (var i = 0; i < this.markers_.length; i += 1) {
                delete this.markers_[i];
            }
            this.markers_ = [];
        }
    };
    /**
     * Close
     * @api
     */
    Meteo.prototype.closePopup = function () {
        this.meteoPopup_.hide();
    };
    /**
     * @private
     */
    Meteo.prototype.createRainWeatherLayer_ = function () {
        var _this = this;
        if (!this.rainWeatherLayer_) {
            var cercaliaMap = this.getCercaliaMap();
            this.rainWeatherLayer_ = new RainWeatherLayer();
            cercaliaMap.addLayer(this.rainWeatherLayer_);
            this.rainWeatherLayer_.on(WeatherLayerEventType.FRAME_CHANGED, function (timestamp) {
                _this.weatherInformation_.updateData(timestamp);
            });
        }
    };
    /**
     * @private
     */
    Meteo.prototype.removeRainWeatherLayer_ = function () {
        var cercaliaMap = this.getCercaliaMap();
        if (this.rainWeatherLayer_) {
            cercaliaMap.removeLayer(this.rainWeatherLayer_);
            this.rainWeatherLayer_ = null;
        }
    };
    /**
     * @private
     */
    Meteo.prototype.createActiveFiresLayer_ = function () {
        if (!this.activeFiresLayer_) {
            var cercaliaMap = this.getCercaliaMap();
            this.activeFiresLayer_ = new ActiveFires();
            cercaliaMap.addLayer(this.activeFiresLayer_);
        }
    };
    /**
     * @private
     */
    Meteo.prototype.removeActiveFiresLayer_ = function () {
        var cercaliaMap = this.getCercaliaMap();
        if (this.activeFiresLayer_) {
            cercaliaMap.removeLayer(this.activeFiresLayer_);
            this.activeFiresLayer_ = null;
        }
    };
    return Meteo;
}(Control));
export default Meteo;
//# sourceMappingURL=Meteo.js.map